import { DataTableSortMeta, DataTableState } from "primevue";

export const MOBILE_BREAKPOINT = 768;
export enum ViewModeKey {
    RESOURCES = 'resources-view-mode',
    CUSTOM_FIELDS = 'custom-fields-view-mode',
    USERS = 'users-view-mode',
    USER_GROUPS = 'user-groups-view-mode'
}

export function getInitialViewMode(viewModeKey: ViewModeKey): 'table' | 'card' {
    if (typeof window === 'undefined') return 'table';

    const savedViewMode = localStorage.getItem(viewModeKey) as 'table' | 'card' | null;
    if (savedViewMode === 'table' || savedViewMode === 'card') {
        return savedViewMode;
    }

    // Fallback to responsive default
    return window.innerWidth < MOBILE_BREAKPOINT ? 'card' : 'table';
}

export function getDataTableSortMetaFromTableState(tableState: DataTableState): string | undefined {
    const sort: DataTableSortMeta[] = (tableState.d_multiSortMeta as any) || []
    const sortParam = sort.length
        ? sort.map(s => `${s.field},${s.order === 1 ? 'asc' : 'desc'}`).join(';')
        : tableState.d_sortField
            ? `${tableState.d_sortField},${tableState.d_sortOrder === 1 ? 'asc' : 'desc'}`
            : undefined

    return sortParam;
}